import React, { useState, useEffect } from 'react';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import 'bootstrap/dist/css/bootstrap.min.css';
import { List, ListItem, ListItemText, ListItemSecondaryAction, IconButton, Select, MenuItem, Card, CardContent, Avatar, Typography, Button, Box, Grid } from '@mui/material';
import Divider from '@mui/material/Divider';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import Loader from 'layouts/nbn/components/loader';

const SERVER_URL = process.env.REACT_APP_API_URL;

const MyWorkPlanDevitionRequestInfo = () => {
    
  const navigate = useNavigate();
  const [reviewers, setReviewers] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate the index of the first and last items to show on the current page
  const indexOfLastReviewer = currentPage * itemsPerPage;
  const indexOfFirstReviewer = indexOfLastReviewer - itemsPerPage;

  // Slice the reviewers list to show only the items for the current page
  const currentReviewers = reviewers.slice(indexOfFirstReviewer, indexOfLastReviewer);

  // Calculate the total number of pages
  const totalPages = Math.ceil(reviewers.length / itemsPerPage);

  // const handlePageChange = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  // };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
        setCurrentPage(newPage);
        // Fetch data or perform necessary actions for the new page
    }
};

  const handleViewDetails = (workPlanId, startDate) => {
    navigate('/my_work_plan_deviation_request_edit', { state: { workPlanId, startDate } });
  };

  const handleWeekChange = async (e) => {

    setLoading(true); // Start loading indicator

    const headers = await getApiHeader();

    try {
      const response = await axios.post(`${SERVER_URL}work-plan/get-my-work-plan-deviation-request-list`, {}, {
        headers: headers
      });

      if (response.data && response.data.data && Array.isArray(response.data.data.work_plan_deviation_data)) {
        setReviewers(response.data.data.work_plan_deviation_data);
      } else {
        setReviewers([]);
      }

    } catch (error) {

      console.error("Error fetching work plan data:", error);

    }finally {
      setLoading(false); // Stop loading after the request finishes (success or failure)
    }
  };


  useEffect(() => {
    handleWeekChange({ target: { value: JSON.stringify({ start: '', end: '' }) } });
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="container workplanform p-3">
        {/* Reviewer List */}
        <Typography variant="subtitle1" className="mt-3"><h4>My Work Plan Deviation List</h4></Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          My Work Plan Deviation List outlines any changes to the planned activities for the week, including new shop visits and store revisits. 
        </Typography>
        {loading ? (
          <div className="text-center">
              <Loader />  {/* You can replace this with a spinner component */}
          </div>
        ) : (
        <div className="table-responsive mt-3">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Sl No</th>
                <th>Retailer Name</th>
                <th>Retailer Code</th>
                <th>Status</th>
                <th>Verified By</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentReviewers.length > 0 ? currentReviewers.map((reviewer, index) => (
                <tr key={reviewer.work_plan_deviation_id}>
                  <td>{indexOfFirstReviewer + index + 1}</td>
                  <td>{reviewer.retailer_name}</td>
                  <td>{reviewer.retailer_code}</td>
                  <td>
                    {reviewer.status === 1 ? 'Approved' :
                      reviewer.status === 2 ? 'Rejected' :
                        'Pending'}
                  </td>
                  <td>
                    {reviewer.verified_by === "admin" ? reviewer.admin_user : 
                        reviewer.verified_by === "manager" ? reviewer.manager_name : "Not Verified"}
                   ({reviewer.verified_by})
                  </td>
                  <td>
                    {reviewer.status == 2 && (
                      <button
                        className="btn btn-danger btn-sm ms-2" style={{ backgroundColor: '#e20e75' }}
                        onClick={() => handleViewDetails(reviewer.work_plan_deviation_id, reviewer.work_week_start_date)}
                      >
                        View Work Details
                      </button>
                    )}
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="6" className="text-center">No Work plan deviations found for the selected week</td>
                </tr>
              )}
            </tbody>
          </table>
          {/* Pagination Controls */}
          {currentReviewers.length > 0 && (
          <div className="pagination-controls text-center">
            <button
                className="btn btn-light btn-sm"
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
            >
                Previous
            </button>
            <span className="mx-2">{currentPage} of {totalPages}</span>
            <button
                className="btn btn-light btn-sm"
                disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => handlePageChange(currentPage + 1)}
            >
                Next
            </button>
        </div>
          )}
        </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default MyWorkPlanDevitionRequestInfo;
